module.exports = __webpack_public_path__ + "assets/img/title-d92a1696.png";